import SigamAPI from '~/utils/SigamAPI';

export default async function UpdateChatParticipants({
  participants,
  chatId,
  institutionId,
}) {
  const response = await SigamAPI({
    url: `/SIGAM/${institutionId}/chat/${chatId}/participants`,
    method: 'PUT',
    data: {
      participants,
    },
  });

  return response;
}
